import React from "react";

import type { LabelProps } from "@busbud/horizon";
import { Label, Link } from "@busbud/horizon";

export type FooterLinkType = {
  link: string;
  label: React.ReactNode;
};

export type FooterLinkProps = FooterLinkType &
  Pick<LabelProps, "id" | "className" | "size" | "iconStart" | "iconEnd"> & {
    linkClassName?: string | undefined;
  };

export const FooterLink: React.FC<FooterLinkProps> = ({
  className,
  linkClassName,
  link,
  size = "md",
  label,
  iconStart,
  iconEnd,
  ...other
}) => {
  return (
    <Link
      disableUnderline
      isMonochrome
      url={link}
      className={linkClassName}
      {...other}
    >
      <Label
        as="span"
        size={size}
        iconStart={iconStart}
        iconEnd={iconEnd}
        fontWeight="bold"
        className={className}
      >
        {label}
      </Label>
    </Link>
  );
};
